// GLOBAL STARTER DEPENDENCIES
import $ from 'jquery'
import '../node_modules/bootstrap/dist/js/bootstrap.js'
console.log('loaded');

// ****************************************************************************
// GLOBAL JAVASCRIPT (COMPILES INTO SCRIPTS-BUNDLE.JS AND SERVED ON EVERY PAGE)
// ****************************************************************************
$(function() {
	$('.navbar-brand a, #headerNav .nav-link').on('click', function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top -100
				}, 1000);
				return false;
			}
		}
	});
});

$(window).on('scroll', function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
        $("#header").addClass("small");
    } else {
        $("#header").removeClass("small");
    }
});



// WEBPACK FOOTER //
// ./scripts/entry.js